export default __webpack_public_path__ + "assets/alta-component.c46968be.svg";